import { FC, ChangeEvent, useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { formatRut } from "react-rut-formatter";
import lRut from 'rut.js'

import './style.scss'
import styles from './RegisterPage.module.css';
import CONFIG from '../../../config'
import { solem } from '../../utils'
import { Layout } from '../../containers'
import { EDocumentType } from '../../models'
import { formData, solemService, userService, auditService, familyMemberService } from '../../services'
import { Button, Card, Radio, Title, Text, Video, Input, Line, FormLabel, FormMessageError, FormMessageInfo, Tooltip, Loading, Icon, FormLabelError, CardInfo } from '../../components/UI'
import { Modal, useModal } from '../../components/UI/Modal'
import documentosImg from '../../assets/img/documento-anterior-nuevo.png'
import { useUserDocumentsTypes } from '../../hooks'
import { RegisterBenefits, StepsRegistrationCedula, StepsRegistrationPassport } from '../../components';

type IAuthRegisterStep1Form = {
  documentTypeId: string,
  documentNumber: string,
  documentNumber2: string,
  email: string,
  cellphone: string
}

const ToolTipDocument = () => <img src={documentosImg} alt="" width="527" height="210" />

const solemOrigin = CONFIG.APP.SOLEM_URL + CONFIG.APP.SOLEM_URL_COMP;
let solemPopup: any
let solemParams: any
let rutData: any
let status_audit: boolean
const defaultValues: IAuthRegisterStep1Form = {
  documentTypeId: String(EDocumentType.rut),
  documentNumber: '',
  documentNumber2: '',
  email: '',
  cellphone: ''
}

const RegisterPage: FC = () => {
  const history = useHistory()
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
    formState
  } = useForm<IAuthRegisterStep1Form>({
    defaultValues,
    mode: 'onChange'
  })
  const [submited, setSubmited] = useState<boolean>()
  const modal = useModal()
  const docType: number = Number(watch('documentTypeId'))
  const documentsTypes = useUserDocumentsTypes()
  //const { familyMember } = useParams<{ familyMember: string }>();
  const query = new URLSearchParams(window.location.search);
  const familyMember = query.get('familyMember');

  console.log('solem url: ', solemOrigin);

  useEffect(() => {
    const fetchFamilyMember = async () => {
      if (familyMember) {
        const resp = await familyMemberService.getNewIntegrand(Number(familyMember))
        setValue('documentTypeId', String(resp?.data?.familyMember?.document_type_id || 1));
        setValue('documentNumber', resp?.data?.familyMember?.document_number || '');
        setValue('email', resp?.data?.familyMember?.email || '');
        setValue('cellphone', resp?.data?.familyMember?.cellphone || '');
      }
    };

    fetchFamilyMember();
  }, [familyMember]);

  useEffect(() => {
    console.log('TEST useEffect remove formData');
    formData.remove()

    const handler = (event: any) => {
      const resp = event.data
      //console.log('Solem handler:', resp, solemOrigin, solemParams)
      if(resp === 'POPUP_LOADED') {
        solemPopup.postMessage(solemParams, solemOrigin)

      } else if(resp && Number(resp.code) >= 0) {
        //console.log('Solem resp:', resp, resp.data)
        solemChange(resp)
        if (solemPopup) solemPopup.close()
      }
    }

    window.addEventListener('message', handler)

    return () => window.removeEventListener('message', handler)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // formatear el rut a partir de 3 digitos
  const documentNumber = watch('documentNumber');
  useEffect(() => {
    if (docType === EDocumentType.passport) {
      return;
    }

    if (documentNumber && documentNumber.length >= 3) {
      const formattedRut = formatRut(documentNumber);
      setValue('documentNumber', formattedRut, { shouldValidate: true });
    } else if (documentNumber === '') {
      setValue('documentNumber', '', { shouldValidate: false });
    }
  }, [documentNumber, setValue]);

  const solemChange = (resp: any) => {
    //console.log('solemChange:', resp)
    if(Number(resp.code) === 0) {
      //console.log('solemChange OK', rutData, resp, CONFIG.ROUTES.AUTH.REGISTER.RUT)
      formData.set({
        ...rutData,
        ...resp
      })
      //console.log('solemChange OK After', formData.get())
      history.push(CONFIG.ROUTES.AUTH.REGISTER.RUT)

    } else {
      //console.log('solemChange Error')
      modal.setMessage(CONFIG.MESSAGE.REGISTER.SOLEM_ERROR)
      modal.open()
    }
  }

  function scrollTo2(idElement = '') {
    const $hook: any = document.getElementById(idElement)
    window.scrollTo({ top: $hook.offsetTop, left: 0, behavior: 'smooth' });
  }
  
  const getPhoneNumber = (number : string) => {
    if (number.length === 9 && number[0] === '9') {
      return number.substring(1);
    }
    return number;
  }

  const solemModal = async (fData: IAuthRegisterStep1Form) => {
    const resp: any = await solemService.getIndentities()
    //console.log('solemModal Srv Resp:', resp, fData)
    if(resp && resp.status === 'Ok') {
      solemParams = solem.getParamsCreate(
        {
          ...resp.data.identity,
          personalNumber: (Number(fData.documentTypeId) === EDocumentType.rut ? lRut.clean(fData.documentNumber) : fData.documentNumber),
          number: fData.documentNumber2,
          cellphone: getPhoneNumber(fData.cellphone),
          email: fData.email,
        }
      )

      rutData = fData
      //console.log('solemModal', solemParams)
      solemPopup = solem.openCheckId(solemOrigin)

      if (solemPopup == null || typeof (solemPopup) == 'undefined') {
        modal.setMessage('Debes habilitar las ventanas emergentes asociadas al Portal del Paciente, para continuar con el proceso de creación de cuenta')
        modal.open(2)
      }
    } else {
      modal.setMessage(CONFIG.MESSAGE.REGISTER.SOLEM_ERROR)
      modal.open()
    }
    setSubmited(false)
  }

  const onDocumentTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target: { value } } = event
    setValue('documentTypeId', value)
    setValue('documentNumber', '')
    setValue('documentNumber2', '')
    clearErrors()
  }

  const scrollTo = async (fData: IAuthRegisterStep1Form) => {


    const $hook: any = document.getElementById("hook")
    window.scrollTo({ top: $hook.offsetTop, left: 0, behavior: 'smooth' });

    const formDocType = Number(fData.documentTypeId)
    await auditService.savePatientRegister({
      status: "sv_register_confirmar",
      document_type_id: formDocType,
      document_number: fData.documentNumber,
      email: fData.email,
      cellphone: fData.cellphone
    })
    status_audit = true
  }
  const onSubmit = async (fData: IAuthRegisterStep1Form) => {
    const formDocType = Number(fData.documentTypeId)
    setSubmited(true)
    const resp: any = await userService.getUserRegistered(formDocType, fData.documentNumber)

    if(resp && resp.status === 'Ok') {
      //console.log(status_audit)
      if (status_audit){
        await auditService.updatePatienteRegister({
          status: "up_register_continuar",
          document_type_id: formDocType,
          document_number: fData.documentNumber
        })
      } else {
        await auditService.savePatientRegister({
          status: "sv_register_continuar",
          document_type_id: formDocType,
          document_number: fData.documentNumber,
          email: fData.email,
          cellphone: fData.cellphone
        })
      }


      if (formDocType === EDocumentType.rut) {
        solemModal(fData)

      } else if (formDocType === EDocumentType.passport) {
        formData.set(fData)
        history.push(CONFIG.ROUTES.AUTH.REGISTER.PASSPORT)
      }

    } else {
      setSubmited(false)
      modal.setMessage(resp.message)
      modal.open(3)
    }
  }


  return (
    <Layout type="public">
      <div className="container register-wrapper pt-40 pb-40 lg:pb-70">
        <RegisterBenefits />

        <Line className="lg:d-none mt-50" />


        <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
          <Card showOnly="lg" className="lg:py-50 lg:px-70 mt-50" style={{ boxShadow: 'none', border: 'none' }}>
            <Title component='h2' weight='600'>Crear nueva cuenta</Title>
            <Text size="13" lineHeight="6" className='pt-10'>Para crear una cuenta en Mi Portal INDISA, completa el formulario con tus datos, verifica tu correo y podrás empezar a gestionar tus citas y servicios médicos en línea.</Text>



            {/* START FORM FIELDS */}
            <div className={styles.fields}>
              {/* 1) N-Documento */}
              <div className={styles.input__container}>
                <div className={styles.document__type__container}>

                  {documentsTypes.data ?
                    documentsTypes.data.map((it: any, i: number) => {
                      const fieldId: string = `${it.name}${i}`
                      return (
                        <div key={i} className={styles.document__type}>
                          <Radio
                            {...register('documentTypeId')}
                            id={fieldId}
                            name="documentTypeId"
                            tabIndex={i + 1}
                            value={it.id}
                            defaultChecked={it.id === defaultValues.documentTypeId}
                            onChange={onDocumentTypeChange}
                          />
                          <Text component="label" htmlFor={fieldId} size="14" weight="semibold">{it.name}</Text>
                        </div>
                      )
                    })
                    :
                    <Loading size="sm" className="align-middle" />
                  }
                </div>

                {docType === EDocumentType.rut &&
                  <>
                    <input
                      {...register('documentNumber', {
                        required: `Digita ${CONFIG.AUTH.LABEL.RUT}`,
                        pattern: {
                          value: CONFIG.FORM.PATTERN.RUT.EXP,
                          message: `Digita ${CONFIG.AUTH.LABEL.RUT} válido`
                        },
                        validate: value => lRut.validate(value) || `Digita ${CONFIG.AUTH.LABEL.RUT} válido`
                      })}
                      id="documentNumber"
                      name="documentNumber"
                      type='text'
                      placeholder={CONFIG.AUTH.PLACEHOLDER.RUT}
                      maxLength={CONFIG.FORM.PATTERN.RUT.MAXLENGHT}
                      tabIndex={3}
                      className={`${styles.form__input} ${!!errors.documentNumber ? styles.form__input__error : ''}`}
                    />
                    {errors.documentNumber && <FormLabelError className="mt-5">{errors.documentNumber?.message}</FormLabelError>}
                  </>
                }

                {docType === EDocumentType.passport &&
                  <>
                    <input
                      {...register('documentNumber', {
                        required: `Digita ${CONFIG.AUTH.LABEL.PASSPORT}`,
                        pattern: {
                          value: CONFIG.FORM.PATTERN.PASSPORT.EXP,
                          message: `Digita ${CONFIG.AUTH.LABEL.PASSPORT} válido`
                        },
                        validate: value => true
                      })}
                      id="documentNumber"
                      name="documentNumber"
                      type='text'
                      placeholder={CONFIG.AUTH.PLACEHOLDER.PASSPORT}
                      tabIndex={3}
                      className={`${styles.form__input} ${!!errors.documentNumber ? styles.form__input__error : ''}`}
                    />
                    {errors.documentNumber && <FormLabelError className="mt-5">{errors.documentNumber?.message}</FormLabelError>}
                  </>
                }
              </div>


              {/* 2) N-Documento */}
              {docType === EDocumentType.rut &&
                <div className={styles.input__container}>
                  <div>
                    <FormLabel htmlFor="documentNumber2" required>Número de documento</FormLabel>
                    <Tooltip
                      color="primary"
                      align="CENTER"
                      className="ml-10 register-tooltip-document"
                    >
                      <ToolTipDocument />
                    </Tooltip>
                  </div>

                  <input
                    {...register('documentNumber2', {
                      required: 'Digita Número de documento',
                      pattern: {
                        value: CONFIG.FORM.PATTERN.DOCUMENTNUMBER.EXP,
                        message: 'Digita Número de documento válido'
                      }
                    })}
                    id="documentNumber2"
                    name="documentNumber2"
                    placeholder="123456789"
                    tabIndex={4}
                    type='text'
                    maxLength={CONFIG.FORM.PATTERN.DOCUMENTNUMBER.MAXLENGHT}
                    className={`${styles.form__input} ${styles.form__input__document__number} ${!!errors.documentNumber2 ? styles.form__input__error : ''}`}
                  />
                  {errors.documentNumber2 && <FormLabelError className="mt-5">{errors.documentNumber2?.message}</FormLabelError>}
                </div>
              }

              {/* 3) Email */}
              <div className={styles.input__container}>
                <FormLabel htmlFor="email" required>E-mail</FormLabel>

                <input
                  {...register('email', {
                    required: 'Digita E-mail',
                    pattern: {
                      value: CONFIG.FORM.PATTERN.EMAIL,
                      message: 'Digita E-mail válido'
                    }
                  })}
                  id="email"
                  name="email"
                  type='email'
                  placeholder="E-mail"
                  tabIndex={4}
                  className={`${styles.form__input} ${!!errors.email ? styles.form__input__error : ''}`}
                />
                {errors.email && <FormLabelError className="mt-5">{errors.email?.message}</FormLabelError>}
              </div>

              {/* 4) Repeat email */}


              {/* 5) Cellphone */}
              <div className={styles.input__container}>
                <FormLabel htmlFor="cellphone" required>Celular</FormLabel>

                <div
                  className={styles.cellphone__input__container}
                >
                  <div className={styles.cellphone__container__code}>56</div>

                  <input
                    {...register('cellphone', {
                      required: 'Digita Celular',
                      pattern: {
                        value: CONFIG.FORM.PATTERN.PHONE.EXP,
                        message: 'Digita celular válido'
                      }
                    })}
                    maxLength={CONFIG.FORM.PATTERN.PHONE.MAXLENGHT}
                    id="cellphone"
                    name="cellphone"
                    type='text'
                    placeholder="912345678"
                    tabIndex={5}
                    className={`${styles.form__input} ${styles.cellphone__input} ${!!errors.cellphone ? styles.form__input__error : ''}`}
                    />
                  {errors.cellphone && <FormLabelError className="mt-5">{errors.cellphone?.message}</FormLabelError>}
                </div>
              </div>
            </div>

            <Button
              type="submit"
              className="mt-20 mb-40 col-12"
              color={formState.isValid || submited ? 'primary' : 'primary2'}
              tabIndex={4}
              disabled={!formState.isValid || submited}
              //onClick={() => scrollTo2("hook")}
              onClick={handleSubmit(scrollTo)}
            >CONTINUAR</Button>

            <CardInfo title="¿No cuentas con documento?">
              <Text size="14" lineHeight="6" className='pt-10 pb-10'>Si no cuentas con carnet de identidad ni pasaporte, o tienes cualquier otro inconveniente que te impida crear tu cuenta en Mi Portal INDISA, acércate a Servicio al Cliente de nuestra Clínica ubicado en la Torre A piso 2. O en el 1er piso de nuestra Clínica en Maipú.</Text>
              <Text size="14" lineHeight="6" className='pt-10'>Para crear cuenta de menores de edad, el tutor legal debe responder el cuestionario de seguridad digital o acercarse a Servicio al Cliente para realizarlo de manera presencial.</Text>
            </CardInfo>

          </Card>

          <Line className="lg:d-none mt-50" />

          <Card showOnly="lg" className="lg:pt-70 lg:pb-50 lg:px-70 mt-40 lg:mt-50" style={{ boxShadow: 'none', border: 'none' }}>
            <div id={"hook"}></div>
            <Title component='h2' weight='600'>Proceso de validación</Title>
            <Text size="13" lineHeight="6" className='pt-10'>Para realizar el proceso de validación deberás seguir los siguientes pasos:</Text>


            {docType === EDocumentType.rut &&
              <>
                <StepsRegistrationCedula />

                <Button
                  type="submit"
                  color={formState.isValid || submited ? 'primary' : 'primary2'}
                  className="mt-30 col-12"
                  tabIndex={4}
                  disabled={!formState.isValid || submited}
                >CONTINUAR</Button>

                {/*
                <CardInfo title="Disclaimer almacenamiento de datos" marginTop='32px'>
                  <Text size="14" lineHeight="6" className='pt-10 pb-10'>Si no cuentas con carnet de identidad ni pasaporte, o tienes cualquier otro inconveniente que te impida crear tu cuenta en Mi Portal INDISA, acércate a Servicio al Cliente de nuestra Clínica ubicado en la Torre A piso 2. O en el 1er piso de nuestra Clínica en Maipú.</Text>
                </CardInfo>
                */}
              </>
            }

            {docType === EDocumentType.passport &&
              <>
                <StepsRegistrationPassport />

                <Button
                  type="submit"
                  color={formState.isValid || submited ? 'primary' : 'primary2'}
                  className="mt-30 col-12"
                  tabIndex={4}
                  disabled={!formState.isValid || submited}
                >CONTINUAR</Button>

                <CardInfo title="Información" marginTop='32px'>
                  <Text size="14" lineHeight="6" className='pt-10 pb-10'>
                    Ten en cuenta que el registro mediante pasaporte debe pasar por un proceso de validación de identidad, por lo que será efectivo dentro de aproximadamente 48 horas hábiles, luego de las cuales ya estarás habilitado para acceder a Mi Portal INDISA.
                  </Text>
                </CardInfo>
              </>
            }
          </Card>
        </form>
      </div>

      <Modal show={modal.show} maxWidth="345px" onClose={() => modal.close()}>
        {modal.index === 1 &&
          <FormMessageError
            message={modal.message}
            className="pt-80 pb-70 px-15"
            onClick={() => modal.close()}
          />
        }
        {modal.index === 2 &&
          <FormMessageInfo
            message={modal.message}
            className="pt-80 pb-70 px-15"
            onClick={() => modal.close()}
          />
        }
        {modal.index === 3 &&
          <FormMessageError
            message={modal.message}
            className="pt-80 pb-70 px-15"
            buttonText="Ingresar"
            onClick={() => history.push(CONFIG.ROUTES.HOME)}
          />
        }
      </Modal>
    </Layout>
  )
}

export { RegisterPage }